export const passwordValidation = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]$/

export const uppyStrings = {
  strings: {
    dropPasteFiles: '%{browseFiles}',
    browseFiles: 'Browse Files',
  },
} as const

export const ENABLE_TIERS =
  process.env.REACT_APP_ENABLE_TIER_FUNCTIONALITY === 'true'
